import { ComponentType } from 'react';
import {
  PatientCheckInView,
  usePatientCheckInView,
  useResetPatientCheckInOnUnmount,
} from '../../../context/patient/modules/checkIn';
import { PatientCheckInCodeInput } from './PatientCheckInCodeInput';
import { PatientCheckInNoCodeInput } from './PatientCheckInNoCodeInput';
import { PatientCheckInPickSite } from './PatientCheckInPickSite';
import { PatientCheckInSuccess } from './PatientCheckInSuccess';
import { PatientPreCheckIn } from './PatientPreCheckIn';
import { PatientPreCheckInNo } from './PatientPreCheckInNo';

export const PatientCheckInPage = () => {
  const view = usePatientCheckInView();

  let Page: ComponentType | undefined;
  switch (view) {
    case PatientCheckInView.Disabled:
      Page = undefined;
      break;
    case PatientCheckInView.PickSite:
      Page = PatientCheckInPickSite;
      break;
    case PatientCheckInView.PreCheckIn:
      Page = PatientPreCheckIn;
      break;
    case PatientCheckInView.PreCheckInNo:
      Page = PatientPreCheckInNo;
      break;
    case PatientCheckInView.CodeInput:
      Page = PatientCheckInCodeInput;
      break;
    case PatientCheckInView.NoCodeInput:
      Page = PatientCheckInNoCodeInput;
      break;
    case PatientCheckInView.Success:
      Page = PatientCheckInSuccess;
  }

  useResetPatientCheckInOnUnmount();

  return Page ? <Page /> : null;
};
